const sharedButtonSx = {
  padding: "4px 10px",
  minWidth: 0,
  fontSize: 11,
  fontWeight: 500,
  borderRadius: "5px",
  textTransform: "none" as const,
  lineHeight: 1.4,
  transition: "background 0.1s",
  ".MuiButton-startIcon svg, .MuiButton-endIcon svg": { width: 12, height: 12 },
};

export const prevButtonSx = {
  ...sharedButtonSx,
  color: "rgba(255,255,255,0.85)",
  border: "1px solid rgba(255,255,255,0.18)",
  background: "rgba(255,255,255,0.1)",
  "&:hover": { background: "rgba(255,255,255,0.18)" },
  "&.Mui-disabled": {
    color: "rgba(255,255,255,0.25)",
    borderColor: "rgba(255,255,255,0.08)",
  },
};

export const nextButtonSx = {
  ...sharedButtonSx,
  color: "#fff",
  border: "1px solid #81D647",
  background: "#81D647",
  "&:hover": { background: "#68AC39", borderColor: "#68AC39" },
  "&.Mui-disabled": {
    background: "#81D647",
    borderColor: "#81D647",
    color: "#fff",
    opacity: 0.4,
  },
};

export const counterSx = {
  fontSize: 11,
  fontWeight: 600,
  color: "#fff",
  background: "rgba(255,255,255,0.15)",
  borderRadius: "4px",
  padding: "3px 10px",
  minWidth: 52,
  textAlign: "center" as const,
  whiteSpace: "nowrap" as const,
};

export const fileNameSx = {
  fontSize: 12,
  color: "rgba(255,255,255,0.75)",
  whiteSpace: "nowrap" as const,
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "600px",
};

export const separatorSx = {
  width: "1px",
  height: "16px",
  background: "rgba(255,255,255,0.15)",
  mx: "2px",
};
